var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_466_11309)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.984 0.815918H15.36C14.688 0.815918 14.16 1.34392 14.16 2.01592C14.16 2.68792 14.688 3.21592 15.36 3.21592H19.056L14.64 7.63192C11.232 5.08792 6.38399 5.32792 3.31199 8.39992C-0.0480077 11.7599 -0.0480077 17.2799 3.31199 20.6399C6.67199 23.9999 12.192 23.9999 15.552 20.6399C18.624 17.5679 18.912 12.6719 16.32 9.31192L20.736 4.89592V8.63992C20.736 9.31192 21.264 9.83992 21.936 9.83992C22.608 9.83992 23.136 9.31192 23.136 8.63992V2.01592C23.184 1.34392 22.656 0.815918 21.984 0.815918ZM13.92 18.9599C11.472 21.4079 7.48799 21.4079 5.03999 18.9599C2.59199 16.5119 2.59199 12.5279 5.03999 10.0799C7.48799 7.63192 11.472 7.63192 13.92 10.0799C16.368 12.5279 16.368 16.5119 13.92 18.9599Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_466_11309"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMale);
export default __webpack_public_path__ + "static/media/MALE.ea8ba8598f00e6672a484a4ce7e80b82.svg";
export { ForwardRef as ReactComponent };